import { Box, Typography } from '@mui/material'
import { t } from 'i18next'
import { FC } from 'react'
import { SessionService } from '../../services/session'
import { Fa } from '../Fa'
import { SessionSummary } from '../SessionSummary'

const Result: FC<ResultProps> = ({ session }) => {
  return (
    <>
      <Typography variant="h1" mb={3}>
        <Fa name="check-circle" size="2xl" color="success" />
      </Typography>
      <Typography variant="h1" mb={1}>
        {session
          ? SessionService.isFullConfirmed(session)
            ? t('You are on the waitlist!')
            : t("You're all booked in!")
          : t('You have successfully purchased.')}
      </Typography>
      <Typography>
        {session
          ? SessionService.isFullConfirmed(session)
            ? t(
                "We'll email you if a spot becomes available. You can also check your class details in the mobile app."
              )
            : t('Open your mobile app to check the details of your class.')
          : t('Open your mobile app to check the details.')}
      </Typography>
      {session && (
        <Box mt={3}>
          <SessionSummary session={session} wrapped />
        </Box>
      )}
    </>
  )
}

type ResultProps = {
  session?: Dto.MarketSession
}

export { Result }
export type { ResultProps }
